import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { ShippingAddressDto } from "@app/modules/dashboard/modules/finance-management/shipping-address/model/shipping-address.dto";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-shipping-address-form",
  templateUrl: "./shipping-address-form.component.html",
  styleUrls: ["./shipping-address-form.component.scss"],
})
export class ShippingAddressFormComponent implements OnInit, AfterViewInit {
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @ViewChild("ShippingAddressForm", { static: true })
  private shippingAddressForm: any;
  @Input() entity: ShippingAddressDto = new ShippingAddressDto();
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() current_accountId: number;
  @Output() saveFunction = new EventEmitter<any>();
  @Output() updateFunction = new EventEmitter<any>();
  title = "";
  loading = false;

  alertType: string;
  alertMessage: string;
  errorShow = false;
  alertShow = false;
  countryList = [];
  regionList = [];
  stateList = [];
  cityList = [];
  countyList = [];
  countryChange = false;
  regionChange = false;
  stateChange = false;
  cityChange = false;
  regionStatus = false;
  stateStatus = false;
  changeStatus = false;

  constructor(
    private klLoadingService: KlLoadingService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private apiService: ApiService,
    private toastService: ToastService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.entity.type = "SHIPPING";
    this.klLoadingService.show("loading");
    switch (this.mode) {
      case "add":
        this.generateCode();
        this.apiService.getLocationsByType("COUNTRY").subscribe(
          (resCountry) => {
            this.countryList = resCountry;
            if (this.countryList.length > 0) {
              this.entity.country = this.countryList[0];
              this.apiService
                .getLocationExist(this.entity.country.id, "region")
                .subscribe(
                  (check) => {
                    this.regionStatus = check.exists;
                    if (check.exists) {
                      this.apiService
                        .getLocationByParentId(this.entity.country.id)
                        .subscribe(
                          (regions) => {
                            this.klLoadingService.hide();
                            this.regionList = regions;
                            this.cd.markForCheck();
                          },
                          (error) => this.handleError(error)
                        );
                    } else {
                      this.apiService
                        .getLocationExist(this.entity.country.id, "state")
                        .subscribe(
                          (checkState) => {
                            this.stateStatus = checkState.exists;
                            if (checkState.exists) {
                              this.apiService
                                .getLocationByParentId(this.entity.country.id)
                                .subscribe(
                                  (states) => {
                                    this.klLoadingService.hide();
                                    this.stateList = states;
                                    this.cd.markForCheck();
                                  },
                                  (error) => this.handleError(error)
                                );
                            } else {
                              this.apiService
                                .getLocationByParentId(this.entity.country.id)
                                .subscribe(
                                  (cities) => {
                                    this.klLoadingService.hide();
                                    this.cityList = cities;
                                    this.cd.markForCheck();
                                  },
                                  (error) => this.handleError(error)
                                );
                            }
                          },
                          (error) => this.handleError(error)
                        );
                    }
                  },
                  (error) => this.handleError(error)
                );
            } else {
              this.klLoadingService.hide();
            }
          },
          (error) => this.handleError(error)
        );
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("shipping_address");
        break;
      case "edit":
      case "view":
        this.apiService.getLocationsByType("COUNTRY").subscribe(
          (resCountryList) => {
            this.countryList = resCountryList;
            if (this.entity.country) {
              this.countryList.filter((filterCountry) => {
                if (filterCountry.id === this.entity.country.id) {
                  this.entity.country = filterCountry;
                }
              });
              this.apiService
                .getLocationExist(this.entity.country.id, "REGION")
                .subscribe(
                  (resRegionExists) => {
                    this.regionStatus = resRegionExists.exists;
                    if (this.regionStatus) {
                      /* Bolge varsa */
                      this.apiService
                        .getLocationByParentId(this.entity.country.id)
                        .subscribe(
                          (resRegionList) => {
                            this.regionList = resRegionList;
                            if (this.entity.region) {
                              this.regionList.filter((filterRegion) => {
                                if (filterRegion.id === this.entity.region.id) {
                                  this.entity.region = filterRegion;
                                }
                              });
                              this.apiService
                                .getLocationExist(
                                  this.entity.region.id,
                                  "STATE"
                                )
                                .subscribe(
                                  (resStateExists) => {
                                    /* Bolge ve Eyalet var */
                                    this.stateStatus = resStateExists.exists;
                                    if (this.stateStatus) {
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.region.id
                                        )
                                        .subscribe(
                                          (resStateList) => {
                                            this.stateList = resStateList;
                                            if (this.entity.state) {
                                              this.stateList.filter(
                                                (filterState) => {
                                                  if (
                                                    filterState.id ===
                                                    this.entity.state.id
                                                  ) {
                                                    this.entity.state =
                                                      filterState;
                                                  }
                                                }
                                              );
                                              this.apiService
                                                .getLocationByParentId(
                                                  this.entity.state.id
                                                )
                                                .subscribe(
                                                  (resCityList) => {
                                                    this.cityList = resCityList;
                                                    if (this.entity.city) {
                                                      this.cityList.filter(
                                                        (filterCity) => {
                                                          if (
                                                            filterCity.id ===
                                                            this.entity.city.id
                                                          ) {
                                                            this.entity.city =
                                                              filterCity;
                                                          }
                                                        }
                                                      );
                                                      this.apiService
                                                        .getLocationByParentId(
                                                          this.entity.city.id
                                                        )
                                                        .subscribe(
                                                          (resCountyList) => {
                                                            this.countyList =
                                                              resCountyList;
                                                            if (
                                                              this.entity.county
                                                            ) {
                                                              this.countyList.filter(
                                                                (
                                                                  filterCounty
                                                                ) => {
                                                                  if (
                                                                    filterCounty.id ===
                                                                    this.entity
                                                                      .county.id
                                                                  ) {
                                                                    this.entity.county =
                                                                      filterCounty;
                                                                  }
                                                                }
                                                              );
                                                            }
                                                            this.klLoadingService.hide();
                                                            this.cd.markForCheck();
                                                          },
                                                          (errCountyList) => {
                                                            this.handleError(
                                                              errCountyList
                                                            );
                                                          }
                                                        );
                                                    } else {
                                                      this.klLoadingService.hide();
                                                      this.cd.markForCheck();
                                                    }
                                                  },
                                                  (errCityList) => {
                                                    this.handleError(
                                                      errCityList
                                                    );
                                                  }
                                                );
                                            } else {
                                              this.klLoadingService.hide();
                                              this.cd.markForCheck();
                                            }
                                          },
                                          (errStateList) => {
                                            this.handleError(errStateList);
                                          }
                                        );
                                    } else {
                                      /* Bolge var eyalet yok */
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.region.id
                                        )
                                        .subscribe(
                                          (resCityList) => {
                                            this.cityList = resCityList;
                                            if (this.entity.city) {
                                              this.cityList.filter(
                                                (filterCity) => {
                                                  if (
                                                    filterCity.id ===
                                                    this.entity.city.id
                                                  ) {
                                                    this.entity.city =
                                                      filterCity;
                                                  }
                                                }
                                              );
                                              this.apiService
                                                .getLocationByParentId(
                                                  this.entity.city.id
                                                )
                                                .subscribe(
                                                  (resCountyList) => {
                                                    this.countyList =
                                                      resCountyList;
                                                    if (this.entity.county) {
                                                      this.countyList.filter(
                                                        (filterCounty) => {
                                                          if (
                                                            filterCounty.id ===
                                                            this.entity.county
                                                              .id
                                                          ) {
                                                            this.entity.county =
                                                              filterCounty;
                                                          }
                                                        }
                                                      );
                                                    }
                                                    this.klLoadingService.hide();
                                                    this.cd.markForCheck();
                                                  },
                                                  (errCountyList) => {
                                                    this.handleError(
                                                      errCountyList
                                                    );
                                                  }
                                                );
                                            } else {
                                              this.klLoadingService.hide();
                                              this.cd.markForCheck();
                                            }
                                          },
                                          (errCityList) => {
                                            this.handleError(errCityList);
                                          }
                                        );
                                    }
                                  },
                                  (errStateExists) => {
                                    this.handleError(errStateExists);
                                  }
                                );
                            } else {
                              this.klLoadingService.hide();
                              this.cd.markForCheck();
                            }
                          },
                          (errRegionList) => {
                            this.handleError(errRegionList);
                          }
                        );
                    } else {
                      /* Bolge yok */
                      this.apiService
                        .getLocationExist(this.entity.country.id, "STATE")
                        .subscribe(
                          (resStateExists) => {
                            this.stateStatus = resStateExists.exists;
                            if (this.stateStatus) {
                              this.apiService
                                .getLocationByParentId(this.entity.country.id)
                                .subscribe(
                                  (resStateList) => {
                                    this.stateList = resStateList;
                                    if (this.entity.state) {
                                      this.stateList.filter((filterState) => {
                                        if (
                                          filterState.id ===
                                          this.entity.state.id
                                        ) {
                                          this.entity.state = filterState;
                                        }
                                      });
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.state.id
                                        )
                                        .subscribe(
                                          (resCityList) => {
                                            this.cityList = resCityList;
                                            if (this.entity.city) {
                                              this.cityList.filter(
                                                (filterCity) => {
                                                  if (
                                                    filterCity.id ===
                                                    this.entity.city.id
                                                  ) {
                                                    this.entity.city =
                                                      filterCity;
                                                  }
                                                }
                                              );
                                              this.apiService
                                                .getLocationByParentId(
                                                  this.entity.city.id
                                                )
                                                .subscribe(
                                                  (resCountyList) => {
                                                    this.countyList =
                                                      resCountyList;
                                                    if (this.entity.county) {
                                                      this.countyList.filter(
                                                        (filterCounty) => {
                                                          if (
                                                            filterCounty.id ===
                                                            this.entity.county
                                                              .id
                                                          ) {
                                                            this.entity.county =
                                                              filterCounty;
                                                          }
                                                        }
                                                      );
                                                    }
                                                    this.klLoadingService.hide();
                                                    this.cd.markForCheck();
                                                  },
                                                  (errCountyList) => {
                                                    this.handleError(
                                                      errCountyList
                                                    );
                                                  }
                                                );
                                            }
                                          },
                                          (errCityList) => {
                                            this.handleError(errCityList);
                                          }
                                        );
                                    }
                                  },
                                  (errStateList) => {
                                    this.handleError(errStateList);
                                  }
                                );
                            } else {
                              /* Bolge Eyalet yoksa */
                              this.apiService
                                .getLocationByParentId(this.entity.country.id)
                                .subscribe(
                                  (resCityList) => {
                                    this.cityList = resCityList;
                                    if (this.entity.city) {
                                      this.cityList.filter((filterCity) => {
                                        if (
                                          filterCity.id === this.entity.city.id
                                        ) {
                                          this.entity.city = filterCity;
                                        }
                                      });
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.city.id
                                        )
                                        .subscribe(
                                          (resCountyList) => {
                                            this.countyList = resCountyList;
                                            if (this.entity.county) {
                                              this.countyList.filter(
                                                (filterCounty) => {
                                                  if (
                                                    filterCounty.id ===
                                                    this.entity.county.id
                                                  ) {
                                                    this.entity.county =
                                                      filterCounty;
                                                  }
                                                }
                                              );
                                            }
                                            this.klLoadingService.hide();
                                            this.cd.markForCheck();
                                          },
                                          (errCountyList) => {
                                            this.handleError(errCountyList);
                                          }
                                        );
                                    }
                                  },
                                  (errCityList) => {
                                    this.handleError(errCityList);
                                  }
                                );
                            }
                          },
                          (errStateExists) => {
                            this.handleError(errStateExists);
                          }
                        );
                    }
                  },
                  (errRegionExists) => {
                    this.handleError(errRegionExists);
                  }
                );
            } else {
              this.klLoadingService.hide();
              this.cd.markForCheck();
            }
          },
          (errCountryList) => {
            this.handleError(errCountryList);
          }
        );
        this.title = this.translateService.instant("shipping_address") + " - ";
        break;
    }
  }

  ngAfterViewInit(): void {
    this.elementFocus.nativeElement.focus();
  }

  commitSave(type) {
    if (this.shippingAddressForm.valid) {
      switch (type) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.saveFunction.emit({ item: this.entity, close: true });
              break;
            case "edit":
              this.updateFunction.emit(this.entity);
              break;
          }
          break;
        case "SAVE_NEW":
          this.saveFunction.emit({ item: this.entity, close: false });
          this.clearForm();
          break;
      }
    } else {
      this.errorShow = true;
      this.alertType = "error";
      this.alertMessage = "required_fields_must_be_entered";
    }
  }

  clearForm() {
    Object.keys(this.entity).forEach((key) => {
      delete this.entity[key];
    });
    this.generateCode();
    this.alertShow = false;
    this.errorShow = false;
    this.entity.country =
      this.countryList.length > 0 ? this.countryList[0] : null;
  }

  generateCode() {
    this.apiService.generateCode("current-account/address").subscribe(
      (resCode) => {
        this.entity.code = resCode.value;
        this.cd.markForCheck();
      },
      (errCode) => {
        this.handleError(errCode);
        this.cd.markForCheck();
      }
    );
  }

  onCountryChange(event) {
    this.regionList = [];
    this.stateList = [];
    this.cityList = [];
    this.countyList = [];
    this.entity.region = null;
    this.entity.state = null;
    this.entity.city = null;
    this.entity.county = null;
    this.countryChange = true;
    this.changeStatus = true;
    this.apiService.getLocationExist(event.value.id, "region").subscribe(
      (check) => {
        this.regionStatus = check.exists;
        if (check.exists) {
          this.apiService.getLocationByParentId(event.value.id).subscribe(
            (regions) => {
              this.countryChange = false;
              this.changeStatus = false;
              this.regionList = regions;
              this.cd.markForCheck();
            },
            (error) => this.handleError(error)
          );
        } else {
          this.apiService.getLocationExist(event.value.id, "state").subscribe(
            (checkState) => {
              this.stateStatus = checkState.exists;
              if (checkState.exists) {
                this.apiService.getLocationByParentId(event.value.id).subscribe(
                  (states) => {
                    this.countryChange = false;
                    this.changeStatus = false;
                    this.stateList = states;
                    this.cd.markForCheck();
                  },
                  (error) => this.handleError(error)
                );
              } else {
                this.apiService.getLocationByParentId(event.value.id).subscribe(
                  (cities) => {
                    this.countryChange = false;
                    this.changeStatus = false;
                    this.cityList = cities;
                    this.cd.markForCheck();
                  },
                  (error) => this.handleError(error)
                );
              }
            },
            (error) => this.handleError(error)
          );
        }
      },
      (error) => this.handleError(error)
    );
  }

  onRegionChange(event) {
    this.regionChange = true;
    this.changeStatus = true;
    this.stateList = [];
    this.cityList = [];
    this.countyList = [];
    this.entity.state = null;
    this.entity.city = null;
    this.entity.county = null;
    this.apiService.getLocationExist(event.value.id, "state").subscribe(
      (check) => {
        if (check.exists) {
          this.apiService.getLocationByParentId(event.value.id).subscribe(
            (states) => {
              this.regionChange = false;
              this.changeStatus = false;
              this.stateList = states;
              this.cd.markForCheck();
            },
            (error) => this.handleError(error)
          );
        } else {
          this.apiService.getLocationByParentId(event.value.id).subscribe(
            (cities) => {
              this.regionChange = false;
              this.changeStatus = false;
              this.cityList = cities;
              this.cd.markForCheck();
            },
            (error) => this.handleError(error)
          );
        }
      },
      (error) => this.handleError(error)
    );
  }

  onStateChange(event) {
    this.cityList = [];
    this.countyList = [];
    this.entity.city = null;
    this.entity.county = null;
    this.stateChange = true;
    this.changeStatus = true;
    this.apiService.getLocationExist(event.value.id, "city").subscribe(
      (check) => {
        if (check.exists) {
          this.apiService.getLocationByParentId(event.value.id).subscribe(
            (cities) => {
              this.stateChange = false;
              this.changeStatus = false;
              this.cityList = cities;
              this.cd.markForCheck();
            },
            (error) => this.handleError(error)
          );
        }
      },
      (error) => this.handleError(error)
    );
  }

  onCityChange(event) {
    this.countyList = [];
    this.entity.county = null;
    this.cityChange = true;
    this.changeStatus = true;
    this.apiService.getLocationExist(event.value.id, "county").subscribe(
      (check) => {
        if (check.exists) {
          this.apiService.getLocationByParentId(event.value.id).subscribe(
            (counties) => {
              this.cityChange = false;
              this.changeStatus = false;
              this.countyList = counties;
              this.cd.markForCheck();
            },
            (error) => this.handleError(error)
          );
        }
      },
      (error) => this.handleError(error)
    );
  }

  clearCountry() {
    this.entity.country = null;
    this.regionList = [];
    this.entity.region = null;
    this.stateList = [];
    this.entity.state = null;
    this.cityList = [];
    this.entity.city = null;
    this.countyList = [];
    this.entity.county = null;
  }

  clearRegion() {
    this.entity.region = null;
    this.stateList = [];
    this.entity.state = null;
    this.cityList = [];
    this.entity.city = null;
    this.countyList = [];
    this.entity.county = null;
  }

  clearState() {
    this.entity.state = null;
    this.cityList = [];
    this.entity.city = null;
    this.countyList = [];
    this.entity.county = null;
  }

  clearCity() {
    this.entity.city = null;
    this.countyList = [];
    this.entity.county = null;
  }

  handleError(error) {
    this.errorShow = false;
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    this.cd.markForCheck();
  }
}
